import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from 'antd';

import DownArrow from '../../../../assets/DownArrow';
import cfg from '../../../../config.json';
import { UserType } from '../../../../interface';
import { Link } from 'react-router-dom';
import { checkPrivileges, checkSubaccount, getCookie } from '../../../../utils';
import { useHistory } from 'react-router-dom';
import Styles from './index.module.scss';
import { Avatar, Toast } from '@kaleyra/emmy';
import CallBackIcon from '../../../../assets/callBackProfilesIcon.svg'
import { useSelector } from 'react-redux';
import { IStateType } from '../../../../store/models/root.interface';
import { checkSupportRole } from '../../../../utils';

export type MapStateType = {
	profile?: UserType;
};

export type DispatchPropsType = {
	onLogOut: () => void;
	profileSetting?: () => void;
	requestLogin: () => void;
	parentLogout: (callback: any) => void;
};

const UserProfile: React.FC<MapStateType & DispatchPropsType> = ({
	profile,
	onLogOut,
	profileSetting,
	requestLogin,
	parentLogout
}) => {
	const { t } = useTranslation();
	const history = useHistory();
	const [popVisibility, setPopVisibility] = useState(false);
	const {
		profile_picture: picture,
		full_name: name,
		company_name: companyName,
		account_name: accountName,
	} = profile || {};

	const { isKDSPage } = useSelector(
		(state: IStateType) => state.kdsView
	);

	const handleLogOut = () => {
		if (getCookie('is_parent_as_child_session')) {
			parentLogout((resp: any, success: boolean) => {
				if (success) {
					localStorage.removeItem("for-user-id");
					document.cookie = "is_parent_as_child_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
					requestLogin()
					history.push('/subaccounts/manage-subaccounts')
				}
				else {
					localStorage.removeItem("for-user-id");
					document.cookie = "is_parent_as_child_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
					onLogOut()
				}
			})
		}
		else {
			onLogOut();
		};
	}
	const getContent = (): React.ReactNode => {
		return (
			<div className={Styles.contentContainer} style={{fontFamily:isKDSPage ? 'Work Sans' : 'Heebo, sans-serif'}}>
				<div className={Styles.userContainer}>
					<i
						className={'fas fa-user fa-sm fa-fw mr-2 text-gray-400'}
					/>
					<div>
						{
							checkSubaccount() ? (
								<div className={Styles.contentContainer}>
									<span>{accountName}</span>
								</div>
							) :
								<>
									<span>{name}</span>
									<span>{companyName}</span>
								</>
						}
					</div>
				</div>
				<Link
					onClick={() => {
						setPopVisibility(false);
					}}
					to={{
						pathname: cfg.SETTING_V2_PROFILE,
					}}>
					<div className={Styles.anchor}>
						<i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
						{t('myProfile')}
					</div>
				</Link>
				<a
					href={cfg.SUPPORT_URL}
					target="_blank"
					rel="noopener noreferrer"
				>
					<div className={Styles.anchor}>
						<i className="fas fa-question-circle fa-sm fa-fw mr-2 text-gray-400"></i>
						{t('mainSupport')}
					</div>
				</a>
				{checkPrivileges('integration_directory', 'main') &&
					<a
						href={'https://developers.kaleyra.io/docs/overview-integration'}
						target="_blank"
						rel="noopener noreferrer"
					>
						<div className={Styles.anchor}>
							<i className="fas fa-object-group fa-sm fa-fw mr-2 text-gray-400"></i>
							{t('mainIntegrationDirectory')}
						</div>
					</a>
				}
				{checkPrivileges('settings', 'callback_profiles') &&
					<Link
						onClick={() => {
							setPopVisibility(false);
						}}
						to={{
							pathname: cfg.CALLBACK_PROFILES,
						}}>
						<div className={Styles.anchor}>
							<img src={CallBackIcon} alt='call-back' style={{ marginLeft: -2, marginRight: 4 }} height={20} width={20} />
							{t('callbackProfile')}
						</div>
					</Link>
				}
				{checkPrivileges('settings', 'main') &&
					<Link
						onClick={() => {
							setPopVisibility(false);
						}}
						to={{
							pathname: cfg.SETTING_V2_URL,
						}}>
						<div className={Styles.anchor}>
							<i className="fas fa-user-cog fa-sm fa-fw mr-2 text-gray-400"></i>
							{t('mainSettings')}
						</div>
					</Link>
				}
				<button className={Styles.logout} onClick={() => { handleLogOut() }}>
					<i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
					{t('mainLogout')}
				</button>
			</div>
		);
	};

	return (
		<>
			<Popover
				placement={'bottomLeft'}
				trigger={'click'}
				content={getContent()}
				overlayClassName={Styles.popoverWrapper}
				visible={popVisibility}
				onVisibleChange={(val) => setPopVisibility(val)}
			>
				<a>
					<div className={Styles.container}>
						<Avatar imgUrl={picture} name={checkSubaccount() ? accountName : name} />
						<span className={Styles.userName}>{checkSubaccount() ? accountName : name}</span>
						<DownArrow
							height={24}
							width={24}
							className={Styles.dropdown}
							color={'#212B36'}
						/>
					</div>
				</a>
			</Popover>
		</>
	);
};

export default UserProfile;
